import { Route, Routes } from 'react-router-dom'
import routes, { RouteConfig } from '.'
import AuthRoute from './AuthRouter'
import Layout from '../components/Layout'
import { Suspense, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { commAction, userAction } from '../redux/action'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '../utils/const'
import { getPeriodId } from '@/utils/getPeriodId'

const App = () => {
	// 处理我们的routers
	const routeAuthFun = (routeList: RouteConfig[]) => {
		return routeList.map(item => {
			return (
				<Route
					path={item.path}
					element={
						<Suspense fallback={<div>稍等</div>}>
							<AuthRoute auth={item.auth} key={item.path}>
								{item.element}
							</AuthRoute>
						</Suspense>
					}
					key={item.path}
				>
					{/* 递归调用，因为可能存在多级的路由 */}
					{item?.children && routeAuthFun(item.children)}
				</Route>
			)
		})
	}

	const dispatch = useDispatch()

	useEffect(() => {

		// 设置学段
		const periodId = getPeriodId()
		dispatch({
			type: commAction.PERIOD_Id, payload: periodId
		})

		const token = Cookies.get(TOKEN_KEY)
		if (token) {
			dispatch({ type: commAction.GET_APP_CONF_MODULE })
			dispatch({ type: userAction.GET_TEA_INFO })
			dispatch({ type: commAction.SET_TOKEN, payload: token })
		}
	}, [])

	return (
		/*  */
		<Layout>
			<Routes>{routeAuthFun(routes)}</Routes>
		</Layout>
	)
}
export default App
